// const backendUrl = "http://localhost:3005";
const backendUrl = "https://unstuck-backend-5wkl.onrender.com";
// const backendUrl = "localhost";

export default backendUrl;
